import UserInfoBanner from 'components/UserInfoBanner';
import ServicesBlock from 'components/Services';
import FaqBlock from 'components/FAQ/FaqBlock';
import NewsBlock from 'components/News/NewsBlock';

const MainPage = () => {
  return (
    <>
      <UserInfoBanner />
      <ServicesBlock />
      <FaqBlock />
      <NewsBlock />
    </>
  );
};

export default MainPage;
